import { useMemo, type FC } from 'react';
import { useAuth } from '../../hooks';
import { Button, getColorVar, Icon, Text } from '@kidslabs/mario-nextjs-react-ui-core';
import { useTranslation } from 'next-i18next';
import { LoginFormFooter } from '../login-form-footer';
import type { PhoneLoginViewProps } from './phone-login.types';

import styles from './phone-login.module.css';

export const PhoneLoginView: FC<PhoneLoginViewProps> = ({ headerAction, renderComponent }) => {
    const { t } = useTranslation('auth');
    const { initValidatePhoneData, currentStep } = useAuth();
    const phoneNumberText = useMemo(
        () => initValidatePhoneData?.phoneNumber ?? t('text_your_phone', 'điện thoại của bạn'),
        [t, initValidatePhoneData?.phoneNumber]
    );

    const isShowBackButton = useMemo(() => {
        return currentStep === 'SelectChannel' || currentStep === 'Faq';
    }, [currentStep]);

    const headerContent = useMemo(() => {
        switch (currentStep) {
            case 'EnterPhoneNumber':
                return {
                    title: t('text-welcome', 'Chào mừng bạn đến với KidsPlaza!'),
                    subTitle: t('text-sub', 'Nhập hoặc tạo tài khoản với vài bước đơn giản'),
                };
            case 'SelectChannel':
                return {
                    title: t('text_select_authentication_method'),
                    subTitle: '',
                };
            case 'VerifyOtp':
                return {
                    title: t('text-input-otp-sent'),
                    subTitle: t('text-otp-sent', { number: phoneNumberText }),
                };
            case 'Register':
                return {
                    title: t('text_fill_customer_info', 'Điền thông tin khách hàng'),
                    subTitle: '',
                };
            case 'Faq':
                return {
                    title: t('text_input_otp_sent_via_sms'),
                    subTitle: '',
                };
        }
    }, [currentStep, t, phoneNumberText]);

    return (
        <div className={styles.otpLoginContainer}>
            <div className={styles.headerWrapper}>
                <Button showIf={!!isShowBackButton} variant="text" onClick={headerAction} className={styles.backButton}>
                    <Icon
                        name="chevron-left"
                        containerClassName={styles.backIcon}
                        color={getColorVar('primary', '100')}
                    />
                </Button>

                <div className={styles.header}>
                    <Text className={styles.title}>{headerContent?.title}</Text>
                    <Text showIf={!!headerContent?.subTitle} className={styles.subTitle}>
                        {headerContent?.subTitle}
                    </Text>
                </div>
            </div>

            {renderComponent()}

            {currentStep !== 'Faq' && <LoginFormFooter />}
        </div>
    );
};
